import { UseQueryOptions, useQuery, useQueryClient } from "@tanstack/react-query";
import type { Kycoin, OlkyToken } from "../types";
import { KycoinApiClient } from "../api-client/api-client";

export function useKycoin() {
  const queryClient = useQueryClient();
  const getKycoin = (account_id?: string) =>
    useQuery<Kycoin>({
      queryKey: ["kycoin", account_id],
      queryFn: async () => await KycoinApiClient.getKycoin(account_id)
    });
  const kycoinAccountsQuery = () =>
    useQuery({
      queryKey: ["kycoinAccounts"],
      queryFn: () => KycoinApiClient.getKycoinAccounts()
    });

  const getOlkyToken = (props?: UseQueryOptions<OlkyToken>) =>
    useQuery<OlkyToken>({
      queryKey: props?.queryKey ?? ["olkyToken"],
      queryFn: async () => await KycoinApiClient.olkyToken(),
      ...props
    });

  return {
    queryClient,
    getKycoin,
    kycoinAccountsQuery,
    getOlkyToken
  };
}
